import React from 'react';

/**
 * Turns a nullable context into a non-null context that throws when accessed
 * @param ctx
 */
export function toNonNullContext<T extends React.Context<any>>(
  ctx: T,
  // Because of technical limitations we have to do this a slightly strange way
): () => T extends React.Context<infer K> ? Exclude<K, undefined> : never {
  return () => {
    const value = React.useContext(ctx);
    if (!value) {
      throw Error(`${ctx.displayName} value is undefined`);
    }
    return value;
  };
}
